import styled from 'styled-components/macro';
import useTweetTime, {useTweetDate} from "../utils/tweet_utils";
import {useEffect, useRef, useState} from "react";
import {themecolors} from "../utils/themecolors";
import TweetVideo from "./tweet_video";
import {useRelativeTime} from "../store";
import useWindowDimensions from "../utils/dimensions";

const Heading = styled.div``;
const HeadingLeft = styled.div``;
const Username = styled.div``;
const DisplayName = styled.div``;
const Avatar = styled.div``;
const NameContainer = styled.div``;
const Content = styled.div``;
const Metadata = styled.div``;
const Buttons = styled.div``;
const Likes = styled.div``;
const Replies = styled.div``;
const Retweets = styled.div``;
const Media = styled.div``;
const SingleImage = styled.div``;
const LinkEmbed = styled.div``;
const LinkEmbedText = styled.div``;
const LinkEmbedHeader = styled.div``;
const Domain = styled.div``;
const Title = styled.div``;
const Description = styled.div``;

const Gallery = styled.div``;
const GalleryItem = styled.img``;

const VideoContainer = styled.div``;
const VideoError = styled.div``;
const VideoRetry = styled.div``;

const Poll = styled.div``;
const PollOption = styled.div``;
const PollBar = styled.div``;
const PollLabel = styled.div``;
const PollPercentage = styled.div``;

const Separator = styled.span``;

const TweetEmbed = styled(({embed, data, className}) => {

    const {width} = useWindowDimensions();
    const tweetDetails = data || false;

    const ago = useRelativeTime(tweetDetails.created, false);

    const [videoError, setVideoError] = useState(false);

    const handleVideoError = () => {
        setVideoError(true);
    };

    const mediaRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        if (mediaRef.current) {
            setContainerWidth(mediaRef.current.offsetWidth);
        }
    }, [width]);

    return data && (
        <div className={className} onClick={(e) => {e.stopPropagation()}}>
            <Heading>
                <a href={`https://x.com/${tweetDetails.user.username}/status/${tweetDetails.id}`} target={"_blank"}>
                    <HeadingLeft>
                        <Avatar>
                            <img src={tweetDetails.user.profilePicture} />
                        </Avatar>
                        <NameContainer>
                            <DisplayName>
                                {tweetDetails.user.displayName}
                            </DisplayName>
                            <Username>
                                @{tweetDetails.user.username} <Separator>•</Separator> {ago}
                            </Username>
                        </NameContainer>
                    </HeadingLeft>
                </a>
            </Heading>
            <Content>
                {tweetDetails.content.split('\n').map((line, index, array) => (
                    <div key={index} style={{ paddingBottom: array[index + 1] ? '6px' : 0 }}>
                        {line}
                    </div>
                ))}
            </Content>
            {tweetDetails.video &&
                <Media>
                    <VideoContainer style={{paddingTop: `${tweetDetails.video.heightRatio > 120 ? 100 : tweetDetails.video.heightRatio}%`}}>
                        {videoError ?
                            <VideoError onClick={() => setVideoError(false)}><div>Video failed to load.</div><VideoRetry>Retry</VideoRetry></VideoError>
                            :
                            tweetDetails.video.mpeg ?
                                <TweetVideo data={tweetDetails} />
                                :
                                <video controls playsInline onError={handleVideoError}>
                                    <source src={`${tweetDetails.video.url}#t=0.001`} type="video/mp4"
                                            referrerPolicy="no-referrer"/>
                                    Your browser does not support the video tag.
                                </video>
                        }
                    </VideoContainer>
                </Media>
            }
            {tweetDetails.images.length === 1 &&
            <Media ref={mediaRef}>
                <a
                    href={`https://x.com/${tweetDetails.user.username}/status/${tweetDetails.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {(() => {
                        const { width, height, url } = tweetDetails.images[0];
                        const maxHeight = 480;

                        // scale height down to maxHeight if needed
                        const scaleFactor = height > maxHeight ? maxHeight / height : 1;
                        let scaledWidth = width * scaleFactor;
                        let scaledHeight = height * scaleFactor;

                        // scale down if the image's scaled width is larger than container's width
                        if (scaledWidth > containerWidth && containerWidth > 0) {
                            const widthScaleFactor = containerWidth / scaledWidth;
                            scaledWidth = containerWidth;
                            scaledHeight *= widthScaleFactor;
                        }

                        return (
                            <SingleImage
                                style={{
                                    width: `${scaledWidth}px`,
                                    height: `${scaledHeight}px`,
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={url}
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        display: "block",
                                    }}
                                />
                            </SingleImage>
                        );
                    })()}
                </a>
            </Media>
            }
            {tweetDetails.images.length > 1 &&
                <Media>
                    <a href={`https://x.com/${tweetDetails.user.username}/status/${tweetDetails.id}`} target={"_blank"}>
                        <Gallery data-images={tweetDetails.images.length}>
                            <GalleryItem src={tweetDetails.images[0].url} width="500" height="500" />
                            <GalleryItem src={tweetDetails.images[1].url} width="500" height="500" />
                            {tweetDetails.images.length > 2 &&
                                <GalleryItem src={tweetDetails.images[2].url} width="500" height="500" />
                            }
                            {tweetDetails.images.length > 3 &&
                                <GalleryItem src={tweetDetails.images[3].url} width="500" height="500" />
                            }
                        </Gallery>
                    </a>
                </Media>
            }
            {tweetDetails.poll &&
                <Poll>
                    <PollOption>
                        <PollBar style={{width: `${tweetDetails.poll.options[0].percentage}%`,
                        backgroundColor: tweetDetails.poll.winningPercentage === tweetDetails.poll.options[0].percentage && 'rgba(29, 155, 240, 0.58)'}} />
                        <PollLabel>{tweetDetails.poll.options[0].label}</PollLabel>
                            <PollPercentage>{tweetDetails.poll.options[0].percentage}%</PollPercentage>
                    </PollOption>
                    <PollOption>
                        <PollBar style={{width: `${tweetDetails.poll.options[1].percentage}%`,
                            backgroundColor: tweetDetails.poll.winningPercentage === tweetDetails.poll.options[1].percentage && 'rgba(29, 155, 240, 0.58)'}} />
                            <PollLabel>{tweetDetails.poll.options[1].label}</PollLabel>
                            <PollPercentage>{tweetDetails.poll.options[1].percentage}%</PollPercentage>
                    </PollOption>
                </Poll>
            }
            {tweetDetails.linkEmbed &&
                <LinkEmbed>
                    <a href={tweetDetails.linkEmbed.url} target={"_blank"}>
                        <LinkEmbedHeader style={{backgroundImage: `url(${tweetDetails.linkEmbed.image})`}} />
                        <LinkEmbedText>
                            <Domain>
                                {tweetDetails.linkEmbed.domain}
                            </Domain>
                            <Title>
                                {tweetDetails.linkEmbed.title}
                            </Title>
                        </LinkEmbedText>
                    </a>
                </LinkEmbed>
            }
            {!embed && tweetDetails.quotedTweet && <TweetEmbed embed data={tweetDetails.quotedTweet}/>}
        </div>
    )
})`
  & {
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? '#454546' : '#cfd9de'};
    border-radius: 8px;
    max-width: 540px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#1a1a1b' : '#fff'};
    padding: 16px;
    margin: ${({embed}) => embed ? '12px 0px' : '0'};
  }

  ${Heading} {
    display: flex;
  }
  ${HeadingLeft} {
    display: flex;
    align-items: center;
  }
  ${DisplayName} {
    font-weight: 600;
    font-size: 16px;
  }
  ${Username} {
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? '#77797b' : '#536471'};
    display: flex;
    align-items: center;
  }
  ${Avatar} img {
    border-radius: 50%;
    width: 48px;
    height: 48px;
  }
  ${NameContainer} {
    margin-left: 8px;
    line-height: 22px;
  }
  ${Heading} svg {
    width: 24px;
    height: 24px;
    margin-left: auto;
    fill: rgb(29, 155, 240);
  }
  ${Content} {
    font-size: 16px;
    padding-top: 12px;
  }
  ${Metadata} {
    padding-top: 4px;
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? '#77797b' : '#536471'};
  }
  ${Likes} a,
  ${Replies} a {
    display: flex;
    align-items: center;
  }
  ${Likes} svg, ${Retweets} svg, ${Replies} svg {
    width: 20px;
    height: 20px;
    fill: ${({theme}) => theme.color.name === 'dark' ? '#77797b' : 'rgb(83, 100, 113)'};
    margin-right: 6px;
  }
  ${Buttons} {
    display: flex;
    padding-top: 12px;
  }
  ${Buttons} > div {
    color: ${({theme}) => theme.color.name === 'dark' ? '#77797b' : 'rgb(83, 100, 113)'};
    display: flex;
    font-size: 15px;
    font-weight: 500;
    padding-right: 28px;
    align-items: center;
  }
  ${Media}, ${Poll}, ${LinkEmbed} {
    margin-top: 12px;
  }
  ${Media} ${SingleImage} img,
  ${VideoContainer} video {
    border-radius: 6px;
    background-color: #000;
  }
  ${VideoContainer}, ${SingleImage} {
    height: 0px;
    position: relative;
  }
  ${VideoContainer} video,
  ${SingleImage} img,
  ${VideoError} {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  
  ${Gallery} {
    padding: 0;
    border-radius: 6px;
    overflow: hidden
  }

  ${Gallery} {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 6rem 8rem;
    gap: .2rem
  }

  ${GalleryItem} {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: var(--alt-text-color);
    overflow: hidden
  }

  ${GalleryItem}:nth-child(1):nth-last-child(2), ${GalleryItem}:nth-child(1):nth-last-child(3) {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2
  }

  ${GalleryItem}:nth-child(2):nth-last-child(1) {
    grid-column: 2 / span 1;
    grid-row: 1 / span 2
  }

  ${GalleryItem}:nth-child(2):nth-last-child(2), ${GalleryItem}:nth-child(3):nth-last-child(2) {
    grid-column: 2 / span 1;
    grid-row: 1 / span 1
  }

  ${GalleryItem}:nth-child(3):nth-last-child(1), ${GalleryItem}:nth-child(4):nth-last-child(1) {
    grid-column: 2 / span 1;
    grid-row: 2 / span 1
  }

  ${GalleryItem}:nth-child(1):nth-last-child(4) {
    grid-column: 1 / span 1;
    grid-row: 1 / span 1
  }

  ${GalleryItem}:nth-child(2):nth-last-child(3) {
    grid-column: 1 / span 1;
    grid-row: 2 / span 1
  }
  ${PollOption} {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 6px;
    height: 36px;
    align-items: center;
  }
  ${PollLabel}, ${PollPercentage} {
    z-index: 1;
    padding: 0 12px;
    font-weight: 500;
  }
  ${PollBar} {
    position: absolute;
    background-color: rgb(207, 217, 222);
    width: 50%;
    height: 100%;
    border-radius: 4px;
  }
  ${LinkEmbed} {
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? '#454546' : '#cfd9de'};
    border-radius: 6px;
  }
  ${LinkEmbedText} {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 12px;
    font-size: 15px;
  }
  ${LinkEmbedHeader} {
    border-bottom: 1px solid ${({theme}) => theme.color.name === 'dark' ? '#454546' : '#cfd9de'};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 160px;
    width: 100%;
    background-position: center;
  }
  ${LinkEmbed} ${Title} {
    font-size: 15px;
    overflow: hidden;
    display: -webkit-box;
    //noinspection CssUnknownProperty
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  ${LinkEmbed} ${Domain},
  ${LinkEmbed} ${Title} {
    margin-bottom: 4px;
  }
  ${LinkEmbed} ${Domain} {
    color: ${({theme}) => theme.color.name === 'dark' ? '#77797b' : '#536471'};
  }
  ${VideoError} {
    background-color: #000;
    border-radius: 6px;
    color: ${themecolors.dark_high_impact_text};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 15px;
  }
  ${VideoRetry} {
    font-weight: 500;
    padding-top: 8px;
    font-size: 15px;
  }
  ${Separator} {
    font-size: 8px;
    padding: 0 6px;
  }
`;

export default TweetEmbed;
